import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import localizedStrings from 'localization';
import {
  AppletPreviewButton,
  AppletPreviewContainer,
  AppletPreviewSelected,
  AppletPreviewSelectedIcon,
  AppletPreviewTitle,
  FieldErrorMessage,
  PublishShowcaseAppletsContainer,
  PublishShowcaseDescription,
  QuestSectionTitle,
  RowContainerBackgroundImg,
  ShowcaseBackgroundImg,
  ShowcaseBackgroundImgPreview,
} from 'modules/profile/components';
import { selectAppletsImageToAddShowcase } from 'modules/applets/selectors';
import { QuestApplet } from 'models/QuestApplet';
import AppletPreview from 'modules/profile/portfolio/quest-applets/AppletPreview';
import { StepPropsSplit } from './typings';
import CollapsibleOutlined from 'components/collapsible-outlined';
import { IMAGES_DEFAULT, ValidImageKeys } from 'modules/showcase';
import AppletSelectedCheck from 'assets/icons/AppletSelectedCheck.webp';

const SelectBackgroundImage = ({
  values,
  setFieldValue,
  backgroundUrl,
  showcaseBackground,
  settmpBackgroundImg
}: StepPropsSplit & { backgroundUrl?: string, showcaseBackground?: string, settmpBackgroundImg: React.Dispatch<React.SetStateAction<string | undefined>> }) => {
  const applets = useSelector(selectAppletsImageToAddShowcase);

  const isDefault = useMemo(() => Boolean(IMAGES_DEFAULT[showcaseBackground as ValidImageKeys]), [showcaseBackground])


  const handleAppletSelect = useCallback(
    (applet: QuestApplet) => {
      setFieldValue('backgroundApplet', applet.id);
      settmpBackgroundImg(applet.fileUrl || applet.thumbnailUrl)
    },
    [setFieldValue, settmpBackgroundImg],
  );

  const handleClean = useCallback(() => {
    setFieldValue('backgroundApplet', '');
  },
    [setFieldValue],
  );

  return ((
    <CollapsibleOutlined
      dataTestid="CollapsibleOutlined-SelectBackgroundImage"
      title={<QuestSectionTitle>{localizedStrings.showcaseBackgundImage}</QuestSectionTitle>}
      initOpen={false}
      childrenSelected={<>
        <RowContainerBackgroundImg>
          <ShowcaseBackgroundImgPreview src={backgroundUrl} />
        </RowContainerBackgroundImg>
      </>}
    >
      <>
        <PublishShowcaseDescription>
          {!applets?.length ? (
            <FieldErrorMessage>
              {localizedStrings.showcaseBackgroundMinimumError}
            </FieldErrorMessage>
          ) : localizedStrings.selectShowcaseBackground}
        </PublishShowcaseDescription>

        <PublishShowcaseAppletsContainer>

          {applets.map((applet) => (
            <AppletPreview
              key={applet.id}
              applet={applet}
              onAppletClick={handleAppletSelect}
              showTitle={true}
              height="168px"
              width="178px"
              selected={values.backgroundApplet === applet.id}
            />
          ))}

          {isDefault &&
            <AppletPreviewContainer width={"178px"} margin={'10px'}>
              <AppletPreviewButton
                type="button"
                onClick={handleClean}
                height={"168px"}
                width={"178px"}
                backgroundColor={'transparent'}>

                {!Boolean(values.backgroundApplet) &&
                  <AppletPreviewSelected>
                    <AppletPreviewSelectedIcon src={AppletSelectedCheck} />
                  </AppletPreviewSelected>}
                <ShowcaseBackgroundImg src={backgroundUrl} />
              </AppletPreviewButton>
              <AppletPreviewTitle>Background by default</AppletPreviewTitle>
            </AppletPreviewContainer>}

        </PublishShowcaseAppletsContainer>
      </>
    </CollapsibleOutlined>
  ))
};

export default SelectBackgroundImage;
